<template>
<ViskaseCard>
    <template v-slot:title>
    </template>
    <template v-slot:default>
        <div class="row justify-content-center align-items-stretch p-3">
            <div class="col-12 text-center px-4">
                <div v-html="title" class="h3">
                </div>
            </div>
            <div class="col-6 col-sm-4 col-md-1by5 p-0" v-for="(product, index) in products" :key="index">
                <ViskaseTile>
                    <template v-slot:content >
                      <div @click="gotoProduct(product)">
                        <img class="card-img-top card-viskase" :src="product.img" :alt="product.name" />
                        <button type="button" class="btn btn-viskase">
                            {{ product.title }}
                        </button></div>
                    </template>
                </ViskaseTile>
            </div>
        </div>
    </template>
</ViskaseCard>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
import ViskaseTile from "@/components/core/ViskaseTile.vue";

export default {
  name: "Products",
  components: {
    ViskaseCard,
    ViskaseTile,
  },
  mounted() {},

  data() {
    return {};
  },

  methods: {
    ...mapActions([]),
    ...mapMutations(["setSelectedProduct"]),
    gotoProduct(product) {
      this.setSelectedProduct(product);
      this.$router.push({
        name: "solutions",
        params: {
          language: this.$route.params.language,
          product: product.name,
        },
      });
    },
  },
  computed: {
    ...mapState(["products", "cards", "selectedProduct", "selectedLanguage"]),
    title() {
      var card = this.cards.products || {
        title: "",
      };
      var title = card.title.replace(
        /{product}/g,
        (this.selectedLanguage || {}).name
      );
      return title;
    },
  },
};
</script> 

<style scoped></style>
